import Translation from 'lib/helpers/translation';

export const translations = {
  main: {
    ...Translation.group('main')
  },
  seo: {
    ...Translation.group('seo')
  },
  deals: {
    ...Translation.group('deals')
  }
};
